module.exports = __webpack_public_path__ + "static/media/favicon.b6b4b4be.ico";


//////////////////
// WEBPACK FOOTER
// ./src/landlords/images/favicon.ico
// module id = 193
// module chunks = 0